import React from 'react';

// Components
import MaintainerList from './MaintainerList';

const Maintainers = ({ maintainers }) => (
  <div className="admin-profile-card-list-container">
    <h3>Maintainers</h3>
    <MaintainerList maintainers={maintainers} />
  </div>
)

export default Maintainers



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/ProfileMaintainers.js